function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "link-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.33326 10.8335C8.69113 11.3119 9.14772 11.7078 9.67205 11.9942C10.1964 12.2807 10.7762 12.4511 11.3721 12.4937C11.9681 12.5364 12.5662 12.4504 13.126 12.2416C13.6858 12.0328 14.1942 11.706 14.6166 11.2835L17.1166 8.78347C17.8756 7.99762 18.2956 6.94511 18.2861 5.85263C18.2766 4.76014 17.8384 3.71509 17.0658 2.94256C16.2933 2.17002 15.2482 1.73182 14.1558 1.72233C13.0633 1.71283 12.0108 2.13281 11.2249 2.8918L9.79159 4.3168M11.6666 9.1668C11.3087 8.68836 10.8521 8.29248 10.3278 8.00602C9.80347 7.71955 9.22367 7.5492 8.62771 7.50652C8.03176 7.46384 7.4336 7.54983 6.8738 7.75865C6.314 7.96747 5.80566 8.29424 5.38326 8.7168L2.88326 11.2168C2.12426 12.0026 1.70429 13.0552 1.71378 14.1476C1.72327 15.2401 2.16148 16.2852 2.93401 17.0577C3.70655 17.8302 4.7516 18.2684 5.84408 18.2779C6.93657 18.2874 7.98908 17.8675 8.77492 17.1085L10.1999 15.6835",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6dec211afba0fd788e0528be91005816.svg";
export { ForwardRef as ReactComponent };